module.exports = __webpack_public_path__ + "static/media/005-Lonestar Texas Grill.c0f6d2c4.png";